// CONSTANT FOR FORM
import { anniversaryDateControl, emailAddressControl, employeeBirthDateControl, employeeGenderControl, employeeMarriedTypeControl, firstNameControl, lastNameControl } from '../../../../../constants/form-control/employee/personal-detail';

// INTERFACE AND ENUMS
import { Field, FormFieldConfig } from '../../../../../models/common/forms/form-field-config';
import { ModalType } from '../../../../../models/common/modal/modal-config';

// DATA TYPES
import { FormDataType } from '../../../../../constants/enum/common/form-data-type';

// CONSTANT
import { SAVE_BUTTON_CONFIG } from '../../../../../../app/constants/button';
import { PERSONAL_DETAIL_BUTTON_CONSTANT } from '../../../../../../app/constants/translate-messages/button';
import { FormControlUtil } from '../../../../../../app/core/utils/form-control';
import { ButtonConfig } from '../../../../../../app/models/common/forms/button';
import { textBoxControl } from '../../../../../constants/form-control/core/common/textbox/textbox';
import { payRateEXportCodeControl } from '../../../../../constants/form-control/employee/pay-rate';
import { selectControl } from '../../../../../constants/form-control/core/common/select/select';
import { dateNoFutureControl } from '../../../../../constants/form-control/core/common/date/date-no-future';
import { dateControl } from '../../../../../constants/form-control/core/common/date/date';
import { countryControl } from '../../../../../constants/form-control/core/address';
import { PERMISSION_CONSTANT } from '../../../../../constants/permission';
import { countryCodeControl } from '../../../../../constants/form-control/core/contact/country-code';
import { contactPersonMobileNumber } from '../../../../../constants/form-control/core/contact/contact-person-mobile-no';
import { PERMISSIONV2 } from '../../../../../constants/permissionv2/role-permission';


export const residencyControl: Field = FormControlUtil.mergeFormControl(selectControl, {
  key: 'employee_residency_type',
  templateOptions: FormControlUtil.mergeFormControl(selectControl.templateOptions, {
    label: 'Residency Status',
    bindLabel: 'label',
    bindValue: 'key',
    // selectOptions: {
    //   unClearable: true
    // }
  }),
  validations: { validators: { required: true }},
  options: [{ key: 'Resident', label: 'Resident' }, { key: 'Visa Holder', label: 'Visa Holder' }],
});

/**
 * This constant used for Personal Detail Form
 */
export const PERSONAL_DETAIL_FORM_CONTROLS: FormFieldConfig[] = [
  // {
  //   row: 1,
  //   fields: [
  //     employeeProfileImageControl,
  //   ],
  // },
  {
    row: 2,
    fields: [
      firstNameControl,
      lastNameControl,
    ],
  },
  {
    row: 3,
    fields: [
      emailAddressControl,
      employeeBirthDateControl,
    ],
  },
  {
    row: 4,
    fields: [
      employeeGenderControl,
      FormControlUtil.mergeFormControl(textBoxControl, {
        key: 'user_export_code',
        templateOptions: FormControlUtil.mergeFormControl(textBoxControl.templateOptions, {
          label: 'Export Code',
        }),
        hiddenControl: true,
      }),
    ],
  },
  {
    row: 5,
    fields: [
      FormControlUtil.mergeFormControl(countryCodeControl, { key: 'user_business_country_code', classNames: { main: 'col-md-6' }, validations: { validators: {} } }),
      FormControlUtil.mergeFormControl(contactPersonMobileNumber, { key: 'user_business_mobile_number', classNames: { main: 'col-md-6' }, validations: { validators: {
        required: true
      }, } }),
    ],
  },
  {
    row: 6,
    fields: [
      employeeMarriedTypeControl,
      anniversaryDateControl,
    ],
  },
  {
    row: 7,
    fields: [
      residencyControl,
      FormControlUtil.mergeFormControl(textBoxControl, {
        key: 'employee_visa_type',
        templateOptions: FormControlUtil.mergeFormControl(textBoxControl.templateOptions, { label: 'Visa Type' }),
        visibleExpression: {
          field: 'employee_residency_type',
          value: 'Visa Holder',
        },
      }),
    ],
  },
  {
    row: 8,
    fields: [
      FormControlUtil.mergeFormControl(dateControl, {
        key: 'employee_visa_expiry',
        templateOptions: FormControlUtil.mergeFormControl(dateControl.templateOptions, {
          label: 'Visa Expiry',
          description: 'Notification will be sent before the expiry date'
        }),
        visibleExpression: {
          field: 'employee_residency_type',
          value: 'Visa Holder',
        }
      }),
      FormControlUtil.mergeFormControl(textBoxControl, {
        key: 'employee_passport_number',
        templateOptions: FormControlUtil.mergeFormControl(textBoxControl.templateOptions, { label: 'Passport Number' }),
        visibleExpression: {
          field: 'employee_residency_type',
          value: 'Visa Holder',
        }
      }),
    ],
  },
  {
    row: 9,
    fields: [
      FormControlUtil.mergeFormControl(countryControl, {
        key: 'employee_passport_country',
        templateOptions: FormControlUtil.mergeFormControl(countryControl.templateOptions, {
          label: 'Passport Country'
        }),
        validations: FormControlUtil.mergeFormControl(countryControl.validations, {
          validators: {
            required: false
          },
        }),
        visibleExpression: {
          field: 'employee_residency_type',
          value: 'Visa Holder',
        }
      }),
    ],
  },
];

/**
 * This constant used for Personal Detail Model for payload
 */
export const PERSONAL_DETAIL_FORM_MODEL = {
  employee_id: { type: FormDataType.NUMBER, revert: FormDataType.NUMBER, default: 0 },
  user_first_name: { type: FormDataType.STRING, revert: FormDataType.STRING },
  user_last_name: { type: FormDataType.STRING, revert: FormDataType.STRING },
  user_email_address: { type: FormDataType.STRING, revert: FormDataType.STRING },
  user_business_profile_image_url: { type: FormDataType.STRING, revert: FormDataType.STRING },
  user_business_date_of_birth: { type: FormDataType.DATE, revert: FormDataType.DATE },
  user_business_gender: { type: FormDataType.STRING, revert: FormDataType.STRING },
  user_business_marital_status: { type: FormDataType.STRING, revert: FormDataType.STRING },
  user_business_anniversary_date: { type: FormDataType.DATE, revert: FormDataType.DATE },
  user_export_code: { type: FormDataType.STRING, revert: FormDataType.STRING },
  employee_residency_type: { type: FormDataType.STRING, revert: FormDataType.STRING },
  employee_visa_type: { type: FormDataType.STRING, revert: FormDataType.STRING },
  employee_visa_expiry: { type: FormDataType.DATE, revert: FormDataType.DATE },
  employee_passport_number: { type: FormDataType.STRING, revert: FormDataType.STRING },
  employee_passport_country: { type: FormDataType.STRING, revert: FormDataType.STRING },
  user_business_country_code: { type: FormDataType.STRING, revert: FormDataType.STRING },
  user_business_mobile_number: { type: FormDataType.STRING, revert: FormDataType.STRING },
};

export const ACTIVE_EMPLOYEE_MODAL_CONSTANTS = {
  type: ModalType.WARNING,
  title: 'Active',
  message: 'Employee with given email address was archived in the system. Do you want to unarchive the user?',
  buttons: {
    button1: {
      text: 'Yes',
    },
    button2: {
      text: 'No',
    },
  },
};

/**
 * Button config
 */
export const CUSTOM_SAVE_BUTTON_CONFIG: ButtonConfig = FormControlUtil.mergeFormControl(
  SAVE_BUTTON_CONFIG,
  {
    options: FormControlUtil.mergeFormControl(SAVE_BUTTON_CONFIG.options, {
      text: PERSONAL_DETAIL_BUTTON_CONSTANT.TEXT,
    }),
  },
);

